import React, { useState, useEffect } from 'react';
import './ButtonGrid.css';
import { Link } from "react-router-dom";
import BouleFacette from "../images/Boule-facette-bleu-jaune-05.png";
import Etoile from "../images/etoilev2.png";
import Glace from "../images/glace.png";
import Flute from "../images/flute.png";
import NoticePopup from './NoticePopup.js';
import NoticeIcon from '../images/i.png';
import Contacts from "../images/symbole-contacts.png";
import { Tooltip } from "@mui/material"; 

import { logDev } from "../utils/logger.js";
import { useLanguage } from '../context/LanguageContext.js';

const ButtonGrid = ({ headerHeight }) => {
  const [showNotice, setShowNotice] = useState(false);
  const { t } = useLanguage();

  const handleNoticeClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setTimeout(() => {
      setShowNotice(true);
    }, 10);
  };

  useEffect(() => {
    const debug = (e) => {
      console.log('[clic] sur', e.target);
    };
    document.addEventListener('click', debug);
    return () => document.removeEventListener('click', debug);
  }, []);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      const popup = document.querySelector('.notice-popup');
      const trigger = document.querySelector('.notice-icon');
        
      if (
        (popup && popup.contains(e.target)) ||
        (trigger && trigger.contains(e.target))
      ) {
        return;
      }

      setShowNotice(false);
    };

    if (showNotice) {
      document.addEventListener('click', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [showNotice]);

  return (
    <div>
      <img
        src={NoticeIcon}
        alt="Notice"
        className="notice-icon"
        onClick={handleNoticeClick}
        style={{
          position: 'fixed',
          top: `${headerHeight + 8}px`,
          right: 'clamp(8px, 15vw, 20px)',
          width: 'clamp(10px, 3vw, 30px)',
          height: 'auto',
          cursor: 'pointer',
          zIndex: 3000
        }}
      />
      {showNotice && <NoticePopup onClose={() => setShowNotice(false)} />}

      <h1
        className="page-title"
      >
        {t('Plan')} 
      </h1>

      <div 
      className="button-container"
      >
        <div className="row">
          <Link to="/contacts" className="custom-button image-droite" >
              <img src={Contacts} alt="Contacts" className="contacts-image" />
              {t('CONTACTS')}
          </Link>
          
          <Link to="/survey" className="custom-button">
              <img src={Etoile} alt="Etoile" className="sondage-image" />
              {t('SURVEY')}
          </Link>
        </div>

        <div className="boule-container">
          <Link to="/infos">
          <Tooltip title={t("InfosMap")} arrow>
            <img 
            src={BouleFacette} 
            alt="Illustration" 
            className="BouleFacette-image" 
            style={{ cursor: "pointer" }}
            />
          </Tooltip>
          </Link>
        </div>

        <div className="row">
          <Link to="/menus" className="custom-button image-droite">
              <img src={Glace} alt="Glace" className="glace-image" />
              {t('MENUS')}
          </Link>
          <Link to="/liste" className="custom-button">
              <img src={Flute} alt="Flute" className="flute-image" />
              {t('LIST')}
          </Link>
        </div>
      </div>

      {/* Bouton 1 */ }
      {navigator.share && (
        <button
          className="share-button"
          onClick={() => {
            navigator.share({
              title: t('OrganiZwk'),
              text: t('PlanShareEnjoy'),
              url: window.location.href
            }).catch((err) => logDev("📤 Erreur lors du partage", { message: err.message, stack: err.stack }));
          }}
        >
          📤 {t('share')}
          
        </button>
      )}
    </div>
  );
};

export default ButtonGrid;
